import { render } from "./DescriptionItem.vue?vue&type=template&id=c01d7af6&scoped=true"
import script from "./DescriptionItem.vue?vue&type=script&lang=js"
export * from "./DescriptionItem.vue?vue&type=script&lang=js"

import "./DescriptionItem.vue?vue&type=style&index=0&id=c01d7af6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c01d7af6"]])

export default __exports__